import { querySelectorURL } from "../threads/cpcoc/querySelectorURL";
import { randomNum } from "../threads/cpcoc/randomNum";
export function cachebuster(url) {
    if (querySelectorURL("cachebuster")) {
        const newUrl = new URL(url);
        // add random cachebuster value
        newUrl.searchParams.set("cachebuster", String(randomNum(100, 999)));
        url = newUrl.href;
    }
    return url;
}
